<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">List of Account Payable 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" >Delete</b-button>
          <b-button variant="btn btn-primary mr-1" @click="voidConfirm" :disabled="((model.apvoid==1) || (model.apvoided==1) || (model.posting==0))">Void</b-button>
          <b-dropdown text="Posting" variant="primary mr-1" >
            <b-dropdown-item @click="posting" :disabled="(model.posting == 1 || selected.length>0)">Posting 1</b-dropdown-item>
            <b-dropdown-item @click="postingselected" :disabled="(selected.length==0)">Posting Selected ({{selected.length}}) </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="posting" :disabled="(model.posting != 1 || selected.length>0)">Un Posting 1</b-dropdown-item>
            <b-dropdown-item @click="unpostingselected" :disabled="(selected.length==0)">Unposting Selected ({{selected.length}}) </b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Billing/Invoice</b-dropdown-item>
            <b-dropdown-item @click="printjv" :disabled="(model.posting == 0)">Jurnal Voucher</b-dropdown-item>
            <b-dropdown-item @click="printjvmultiple" :disabled="(selected.length==0)">Jurnal Voucher Selected ({{selected.length}}) </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="printpb" >Perintah Bayar</b-dropdown-item>
            <b-dropdown-item @click="printpbselected" :disabled="(selected.length==0)">Perintah Bayar Selected ({{selected.length}}) </b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="payment()">Payment/Settlement</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" >
        <b-col md="6">
            <b-row>
              <b-col lg="9">
                  <b-input-group >
                    <b-input-group-prepend><label>AP Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder=" % for wildcard"></b-form-input>
                    <b-input-group-prepend><span class="pt-2">Invoice# &nbsp;</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.invoice" placeholder="Request Number"></b-form-input>
                  </b-input-group>
              </b-col>
                <b-col lg="3">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Outstanding &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.YesNoAll"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>          
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

            <b-row>
              <b-col lg="9">
                  <b-input-group >
                    <b-input-group-prepend><label>AP Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Posting &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.postingStatus"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
        </b-col>
        <b-col md="6">
            <b-input-group >
              <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
              <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
                <b-form-input v-model="tblData.uraian" placeholder="Description" class="ml-1"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Purchase Order</label></b-input-group-prepend>
                <b-form-input v-model="tblData.po" placeholder="Purch. Order#" style="width:27% !important;"></b-form-input>
                <b-input-group-prepend><span class="p-2">Inv. DP/Termin</span></b-input-group-prepend>
                <b-form-select v-model="tblData.tagihandp" :plain="true" :options="dataList.YesNoAll"></b-form-select>
                <b-input-group-prepend><span class="p-2">AP Receiving Post.</span></b-input-group-prepend>
                <b-form-select v-model="tblData.receivingposting" :plain="true" :options="dataList.YesNoAll"></b-form-select>
              </b-input-group>

              <b-input-group >
                  <b-input-group-prepend><label>AP Posting Group</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.postgroup" :plain="true" :options="postGroups" style="width:25% !important;"></b-form-select>
                  <b-input-group-prepend><span class="pt-2">Account# &nbsp;</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.kodeacc" placeholder="AP Account Code"></b-form-input>
                  <b-input-group-append>
                        <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                  </b-input-group-append>
                  <b-input-group-append>
                        <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                  </b-input-group-append>
              </b-input-group>

        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="tblDataItems"
        :fields="tblFields"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
         @row-clicked="rowClicked" 
      >
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-apinvkey="data.item.apinvkey"
            :checked="ischeckedjurnal(data.item.apinvkey)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#"  style="padding:0 !important;">Print Invoice/Bill</b-dropdown-item>
          <b-dropdown-item @click="rowPrintpb(data.item)" href="#"  style="padding:0 !important;">Perintah Bayar</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Un Posting</b-dropdown-item>
          <b-dropdown-item @click="rowVoid(data.item)" href="#" :disabled="((data.item.isvoid==1) || (data.item.isvoided==1) || (data.item.posting==0))">Void</b-dropdown-item>
          <b-dropdown-item @click="rowPrintjv(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="rowAttachment(data.item)" href="#"  style="padding:0 !important;">Attachment</b-dropdown-item>
        </b-dropdown>
      </template>          
        <template v-slot:cell(nomor)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">{{data.item.nomor}}</div>
          <div v-else>{{data.item.nomor}}</div>
        </template>

        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(po)="data">
          <div style="font-size:smaller;">{{ data.item.po }} <span style="font-style: italic !important;"> {{data.item.RecivNo}}</span></div>
        </template>
        <template v-slot:cell(totalinv)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{(data.item.totalinv)|numFormat}}
          </div>
          <div v-else> 
            {{(data.item.totalinv)|numFormat}}
          </div>
        </template>

        <template v-slot:cell(outstand)="data">
          {{data.item.outstand | numFormat}}
        </template>
        <template v-slot:cell(download)="data">
                <b-link @click.stop="getAttachment(data.item)"><i class="fa fa-paperclip"></i></b-link>
        </template>
      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>        
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    <b-modal v-model="showReport" scrollable size="xl" title="Preview as PDF" hide-footer>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>
    <b-modal v-model="showPaymentForm" scrollable size="xl" title="AP Payment/Settlement History" hide-footer>
              <b-form-row>
                  <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>AP Number</label></b-input-group-prepend>
                      <b-form-input v-model="paymdata.nomor" readonly></b-form-input>
                  </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>AP Date</label></b-input-group-prepend>
                      <b-form-input v-model="paymdata.tanggal" type="date" disabled></b-form-input>                                        
                  </b-input-group>
                  </b-col>
              </b-form-row >                      
              <b-form-row>
                  <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
                      <b-form-input v-model="paymdata.invoice" readonly></b-form-input>
                  </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Invoice Date</label></b-input-group-prepend>
                      <b-form-input v-model="paymdata.invdate" type="date" disabled></b-form-input>                                        
                  </b-input-group>
                  </b-col>
              </b-form-row >                      
              <b-input-group >
                  <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                  <b-form-input readonly v-model="paymdata.vendorinfo" ></b-form-input>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Purchase Order#</label></b-input-group-prepend>
                  <b-form-input readonly v-model="paymdata.po" ></b-form-input>
                    <b-input-group-prepend><span class="p-2">Description</span></b-input-group-prepend>
                    <b-form-input v-model="paymdata.uraian" readonly style="width:50% !important"></b-form-input>
              </b-input-group>
              <b-form-row>
                  <b-col cols="6" >
                      <b-input-group >
                          <b-input-group-prepend><label>Invoice Amount</label></b-input-group-prepend>
                          <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{paymdata.matauang}}</span></b-input-group-prepend>
                          <my-number class="form-control text-right" separator="," v-model="paymdata.totalinv" :precision="2" readonly ></my-number>
                      </b-input-group>
                  </b-col>
                  <!-- <b-col cols="6">   
                      <b-input-group>
                          <b-input-group-prepend><label>Related to other Invoice #</label></b-input-group-prepend>
                          <b-form-input v-model="model.invoicereff" readonly=""></b-form-input>
                      </b-input-group>
                  </b-col> -->
              </b-form-row>
              <b-card no-body class="mb-1">
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                                <th width="80px">Settlement Date</th>
                                <th width="110px">Doc. Number</th>
                                <th width="110px">Settlement Method</th>
                                <th>Description</th>
                                <th width="90px">Input By</th>
                                <th width="140px" style="text-align:right">Debit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in paymdata.paymLines" :key="row.tablekey" >
                                <td :class="row.kelas">{{row.tanggal | moment("DD MMM YYYY")}}</td>
                                <td :class="row.kelas">{{row.nomor}}</td>
                                <td :class="row.kelas">{{row.paymethod}}</td>
                                <td :class="row.kelas">{{row.uraian}}</td>
                                <td :class="row.kelas">{{row.createby}}</td>
                                <td  :class="row.kelas" style="text-align:right">{{row.nilaibayar | numFormat}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
              </b-card>    
                <b-row class="mt-1">
                    <b-col lg="6">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Total Settlement</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{paymdata.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="paymdata.totalsettle" :precision="2" disabled></my-number>
                            </b-input-group>
                        </div>
                    </b-col>
                    <b-col lg="6">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Oustanding</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{paymdata.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="paymdata.outstand" :precision="2" disabled></my-number>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
    </b-modal>

      <b-modal v-model="showVoidConfirm" title="Void Transcation?" :centered="true" @ok="voidData">
        <p class="mb-1">1 record is about to be Void/Canceled/Reversed</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure to doing this ?</p>
      </b-modal>

      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="Attachment" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>AP Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor" readonly></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row >    
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="200px">Attached Date</th>
                    <th >File Name</th>
                    <th width="100px">Attached By</th>
                    <th width="40px">action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in attachmens" :key="row.attachmentKey">
                    <td> {{row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>                                
                        <b-link @click="attachmentDownload(row)">{{row.attchFileNm}}</b-link>
                    </td>
                    <td>{{row.createby}}</td>
                    <td>                                
                      <div class="text-center" v-if="(model.posting==0)">
                          <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                              <i class="fa fa-trash"></i>
                          </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          <div no-body v-if="(model.posting==0)">
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected File: <strong>{{ file ? file.name : '' }}</strong> Filesize:{{bytesToKB.showFileSize(file)}}</span>   
                  <b-button variant="success" @click="attachmentSave" class="sm" v-if="(file)"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
              </b-row>
          </div>
      </b-modal>

  </div>
</template>

<style lang="scss">
  .list-of-ap {
      table {
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }

}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import myNumber from "../../components/my-number";
import apinv from "../../apis/apinv";
import task from "../../apis/task";
import dropdown from "../../data/dropdown";
import bytesToKB from '../../libs/filesize-byte2kb';
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading,myNumber},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      showVoidConfirm:false,
      showPaymentForm: false,
      paymdata:{ paymLines:[]},
      showAttachment: false,
      attachmens: [],
      bytesToKB,
      file: null,
      isLoading:false,
      showReport:false,
      isprintjv:false,
      reportUrl: null,
      pagination: false,
      limit:15,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: 'tanggal',
        sortDesc: true,
        DimCol:'Dim1'
      },
      tblDataItems:[],
      model:{},deleted:{},
      postGroups:[],selected:[],
      receivingStatus:[{ value: '1', text: 'Received'},{ value: '0', text: 'Not Received'},{ value: '', text: '--- ALL ---'}],
      dataList: {
        YesNoAll: dropdown.ostandStatus,
        postingStatus: dropdown.postingStatus
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "AP. Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "AP. Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "invoice",
            thStyle: "width:100px",
            label: "Invoice #",
            sortable: true
          },
          {
            key: "uraian",
            thStyle: "width:400px",
            label: "Description"
          },
          {
            key: "po",
            label: "PO#",
            thStyle: "width:110px",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "totalinv",
            label: "Invoice Amount",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: 'download',
            label: "Attach",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "nomorbank",
            label: "Bank/Cash Trx.#",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
    "tblData.page": function(newval) {
      this.data();
    },   
    "tblData.limit": function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
    
  },
  created: async function(){
      if (this.$route.params.nomor)  {
           this.clearFilter();
           this.tblData.nomor=this.$route.params.nomor;
      }
      setTimeout(async () => {
        const accList = await apinv.postgroup();
        this.postGroups = accList.reduce((newArr,item) =>{
              newArr.push(item);
              return newArr;
          },[{ value: '', text: '--- ALL ---'}]);
          // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
          // this.tblData.tgl1=this.$store.state.user.tglaktif;
          // this.tblData.tgl2=tgl2.format('YYYY-MM-DD');
        }, 1000);
      this.data();
  },  
  sockets: {
        apinvtrx: function (data) {
            console.log('IO: apinvtrx ',data.source);
            const ada = this.tblDataItems.find(a => a.apinvkey==data.apinvkey)
            if (ada){
              for (var key in data) {
                ada[key] = data[key];
              }
            }

        },
        apinvdeleted: function (data) {
            const index= this.tblDataItems.findIndex(a => a.apinvkey==data.apinvkey)
            this.tblDataItems.splice(index, 1);

        },
    },    

  methods: {
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
      // $('[name="selectjurnal"]').each(function() {
      //     $(this).prop("checked", false);
      //   });
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const apinvkey = item.target.attributes["data-apinvkey"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === apinvkey);
        if (!(findjv)){
          this.selected.push(apinvkey);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === apinvkey);
        this.selected.splice(findIdx, 1);
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.apinvlist) {
            this.tblData[key] = filter.apinvlist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.apinvlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.apinvlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await apinv.list(this.tblData);      
                  this.pagination=true;
                  this.tblDataItems = list;
                  this.isLoading=false;  
                  // return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await apinv.list(this.tblData);      
                  this.pagination=true;
                  this.tblDataItems = list;
                  this.isLoading=false;  
                  // return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    refresh(ctx) {
      if (this.$refs.table) {
        // this.$refs.table.refresh();
        this.data();
      }
    },
    search(ctx) {
      this.tblData.page=1;
      this.data();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.po=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.invoice=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor', 'vendorcode', 'po', 'postgroup', 'posting'];
      let filtered = false;
      const apinvlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              apinvlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          apinvlist.page=this.tblData.page;
          apinvlist.limit=this.tblData.limit;
          apinvlist.sortBy=this.tblData.sortBy;
          apinvlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.apinvlist=apinvlist;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowVoid(record) {
      this.model = record;
      this.voidConfirm();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintjv(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowPrintpb(record) {
      this.rowClicked(record);
        this.printpb();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },    
    add(){
      this.saveFilter();
      router.push({name :"payable.apinvfrm"});
    },
    edit: function() {
        if (this.model.apinvkey) {
          this.saveFilter();
          if (this.model.apvoid) {
              router.push({name :'payable.apinvfrmvoid', params: { apinvkey: this.model.apinvkey}});
          } else {
            router.push({name :'payable.apinvfrm', params: { apinvkey: this.model.apinvkey}});
          }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    editjv: function() {
        if (this.model.apinvkey) {
            this.saveFilter();
            const tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
          // router.push({name :'payable.editjvfrm', params: { nomor: this.model.nomor, tanggal, kodejurnal:'APINV', fsubkode2:'ap_invoice_tt',kodefield2:'apinvkey',subkode2: this.model.apinvkey}});
          router.push({name :'payable.editjvfrm', params: { nomor: this.model.nomor, tanggal: this.model.tanggal}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.apinvkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await apinv.remove(this.model);
      // this.data();
        const index= this.tblDataItems.findIndex(r => (r.apinvkey==this.model.apinvkey));
        this.tblDataItems.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.apinvkey) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingselected: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          await apinv.postingselected(this.selected);
          this.printjvmultiple();
          this.data();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    unpostingselected: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          await apinv.unpostingselected(this.selected);
          this.selected = [];
          this.data();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    postingData: async function(){
        this.isLoading=true;
        try {
            await apinv.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await apinv.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  

    voidConfirm() {
        if (this.model.apinvkey) {
          if (this.model.outstand==this.model.totalinv) {
              this.showVoidConfirm = true;
          } else {
            toastr.warn('AP Invoice already Paid/Adjusted can not be Voided!');
          }
        } else {
            toastr.warn('Please select a row that want to be Voided!');
        }
    },
    voidData: async function() {
        if (this.model.apinvkey) {
          if (this.model.outstand==this.model.totalinv) {
              this.saveFilter();
              router.push({name :'payable.apinvfrmvoid', params: { apinvkey: this.model.apinvkey}});
          } else {
            toastr.warn('AP Invoice already Paid/Adjusted can not be Voided!');
          }
        } else {
            toastr.warn('Please select a row that want to be Voided!');
        }
    },

    printjv: async function()
    {
      if (this.model.apinvkey) {
          try {
              this.showReport=true;
              this.isprintjv=true;
              this.reportUrl= await apinv.printjv(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    print: async function()
    {
      if (this.model) {
          try {
              this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await apinv.print(this.model);

          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printjvmultiple: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await apinv.printjvmultiple(this.selected);
              this.selected = [];
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },
    printpb: async function()
    {
      if (this.model.apinvkey) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await apinv.printpb(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printpbselected: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await apinv.printpbmultiple(this.selected);
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },
    payment: async function() {
        if (this.model.apinvkey) {
            const row={totalsettle:0, outstand:0};
            for (var key in this.model) {
                  row[key] = this.model[key];
              }
              row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
              row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
              this.paymdata=row;
            const ds = await apinv.paymenthistory(this.model);
            this.paymdata.paymLines=ds[0];
            let totalsettle = 0;
            this.paymdata.paymLines.forEach((trx)=> {
                    totalsettle += (trx.nilaibayar || 0);
            });
            this.paymdata.totalsettle = totalsettle;
            this.$forceUpdate();
          this.showPaymentForm=true;
            this.data();
        } else {
            toastr.warn('Please select a row that want to be view the Payment!');
        }
    },    
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await apinv.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/payable/home");
    },
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },
    getAttachment: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await task.getAttachment({taskkey: record.apinvkey});
        this.attachmens=data;    
        this.showAttachment=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log('error : ', error);
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }   
      }
    },    
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (!this.file) {
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.model.apinvkey);
                formData.append('tableName', 'ap_invoice_tt');
                formData.append("filesize", bytesToKB.showFileSize(this.file));
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                const data = await task.getAttachment({taskkey: this.model.apinvkey});
                this.attachmens=data;    
                this.file=null;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },      
    delAttachment : async function(obj) {
      const pesan=`Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal.msgBoxConfirm(pesan, {
      title: 'Please Confirm',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: 'YES',
      cancelTitle: 'NO',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
          if (value==true){
              this.isLoading=true;
                try {
                    await task.delAttachment(obj);
                  const data = await task.getAttachment({taskkey: this.model.apinvkey});
                  this.attachmens=data;    
                    this.isLoading=false;    
                } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
          }
      })
      .catch(err => {
      })                
    },
  }
};
</script>
